import React from 'react';
import LazyLoad from 'react-lazyload';
import { string, bool } from 'prop-types';
import featureCheck from './feature_check.png';
import styles from './styles/styles.module.scss';

const FeatureRow = ({ text, tint, free }) => {
  const classNames = [styles.featureRow];

  if (tint) {
    classNames.push(styles.featureRowTint);
  }

  return (
    <div className={classNames.join(' ')}>
      <div className={[styles.featureRowCell, styles.featureRowText].join(' ')}>{text}</div>
      <div className={[styles.featureRowCell, styles.featureRowFree].join(' ')}>
        {free && (
          <LazyLoad>
            <img src={featureCheck} className={styles.featureCheckIcon} alt="" />
          </LazyLoad>
        )}
      </div>
      <div className={[styles.featureRowCell, styles.featureRowPro].join(' ')}>
        <LazyLoad>
          <img src={featureCheck} className={styles.featureCheckIcon} alt="" />
        </LazyLoad>
      </div>
    </div>
  );
};

FeatureRow.propTypes = {
  text: string.isRequired,
  tint: bool.isRequired,
  free: bool.isRequired
};

export default FeatureRow;
